import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { COMPOSITION_BUFFER_MODE } from "@angular/forms";
import { NzSelectSearchComponent } from "ng-zorro-antd/select";

@Component({
  selector: "ui-select-search",
  templateUrl: "select-search.component.html",
  providers: [{ provide: COMPOSITION_BUFFER_MODE, useValue: false }],
})
export class UiSelectSearchComponent extends NzSelectSearchComponent {
  @Input("uiId") public nzId: string | null = null;
  @Input() public disabled = false;
  @Input() public mirrorSync = false;
  @Input() public showInput = true;
  @Input() public focusTrigger = false;
  @Input() public value = "";
  @Input() public autofocus = false;
  @Output() public readonly valueChange = new EventEmitter<string>();
  @Output() public readonly isComposingChange = new EventEmitter<boolean>();
  @ViewChild("inputElement", { static: true }) public inputElement!: ElementRef;
  @ViewChild("mirrorElement", { static: false }) public mirrorElement?: ElementRef;
}
